import React from "react";
import styles from "./LogoNew.module.scss"
export function LogoNew() {
    return <div className={styles.wrapper}>
            <img className={styles.logo} src={"/swippy-side-logotype.svg"} alt={"logo"} />

        </div>
}